<div *ngIf="(country$ | async)?.banner">{{ (country$|async)?.banner }}</div>

